"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncFirstOr = asyncFirstOr;
exports.default = void 0;

var _asyncIterable = require("../../internal/async-iterable");

async function asyncFirstOr(iterable, whenEmpty) {
  const iter = (0, _asyncIterable.asyncEnsureIterable)(iterable)[Symbol.asyncIterator]();
  const {
    value,
    done
  } = await iter.next();
  if (done) return whenEmpty;
  if (typeof iter.return === 'function') await iter.return();
  return value;
}

var _default = (0, _asyncIterable.asyncIterableCurry)(asyncFirstOr, {
  reduces: true
});

exports.default = _default;